import type { FC } from 'react';

import { useTranslation } from 'react-i18next';

import * as styles from './AgeLimitLabel.module.scss';

type Props = {
  ageLimit?: number | null;
};

const AgeLimitLabel: FC<Props> = ({ ageLimit }) => {
  const { t } = useTranslation();

  if (ageLimit === null || ageLimit === undefined) {
    return null;
  }

  const label = ageLimit === 0 ? 'A' : ageLimit;

  return <span className={styles.ageLimit}>{label}</span>;
};

export { AgeLimitLabel };
